import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import styles from "./TermAndConditions.module.scss";

const TermAndConditions = () => {
  return (
    <Container className={styles.termsContainer}>

      <Box
        className={styles.header}
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography sx={{ fontSize: 20, color: '#1d3d40' }}>
          <b>Meta Terms & Conditions – OTUSONE LLP</b>
        </Typography>
        <Typography sx={{ color: 'gray' }}>
          Effective Date: 01-07-2025
        </Typography>
      </Box>

      <Typography className={styles.paragraph}>
        Welcome to the official website of <strong>OTUSONE LLP</strong>. By
        accessing or using our website and services, you agree to comply with
        and be bound by the following Terms & Conditions. Please read them
        carefully before using our services.
      </Typography>

      <Divider className={styles.divider} />

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>1. Use of Services</b></Typography>
        <ul className={styles.list}>
          <li>Our IT solutions and services are intended for lawful business purposes only.</li>
          <li>You agree not to misuse our services for unlawful, harmful, or fraudulent activities.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>2. Intellectual Property</b></Typography>
        <ul className={styles.list}>
          <li>All website content, logos, graphics, and materials are the property of OTUSONE LLP.</li>
          <li>You may not copy, reproduce, modify, or distribute our content without prior written consent.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>3. Payments & Refunds</b></Typography>
        <ul className={styles.list}>
          <li>Payments for services must be made as per agreed project contracts or invoices.</li>
          <li>Refunds, if applicable, will be handled on a case-by-case basis and in accordance with the terms outlined in your service agreement.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>4. Third-Party Services</b></Typography>
        <ul className={styles.list}>
          <li>We may integrate or rely on third-party tools, APIs, or services (e.g., WhatsApp Business API, hosting providers).</li>
          <li>OTUSONE LLP is not responsible for downtime, data practices, or service issues arising from third-party providers.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>5. Limitation of Liability</b></Typography>
        <ul className={styles.list}>
          <li>OTUSONE LLP shall not be held liable for any indirect, incidental, or consequential damages arising from the use of our services.</li>
          <li>Our maximum liability is limited to the fees paid for the specific service in question.</li>
        </ul>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>6. Termination</b></Typography>
        <Typography className={styles.paragraph}>
          We reserve the right to suspend or terminate services if you violate these Terms or misuse our platform in any way.
        </Typography>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>7. Governing Law</b></Typography>
        <Typography className={styles.paragraph}>
          These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in{" "}
          <strong>Noida, Uttar Pradesh, India</strong>.
        </Typography>
      </Box>

      <Box className={styles.section}>
        <Typography sx={{ color: '#1d3d40' }}><b>8. Contact Information</b></Typography>
        <Typography className={styles.paragraph}>
          For any questions or clarifications regarding these Terms & Conditions, please contact us at:
        </Typography>
        <Box className={styles.contactBox}>
          <Typography><span className={styles.label}>Email:</span> info@otusone.com</Typography>
          <Typography><span className={styles.label}>Phone:</span> +91 9340312713</Typography>
          <Typography><span className={styles.label}>Address:</span> G-903, Ace City, Greater Noida West, Sector 01, 201306</Typography>
          <Typography><span className={styles.label}>Office:</span> H-112, Sector 63, Noida, Uttar Pradesh, 201301</Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default TermAndConditions;